import { frenchDate } from "./frenchDate";

export const formatJsDate = frenchDate;

export const formatJsDateTempo = (date) => {
  const newDate = new Date(date);
  const day = String(newDate.getDate()).padStart(2, "0");
  const month = String(newDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
  const year = newDate.getFullYear();

  return `${year}${month}${day}`;
};

export const formatDateString = frenchDate;
export const formatDate = frenchDate;

export const formatJsDateWithHour = (date) => {
  const newDate = new Date(date);
  const day = String(newDate.getDate()).padStart(2, "0");
  const month = String(newDate.getMonth() + 1).padStart(2, "0"); // Mois de 0 à 11, donc +1
  const year = newDate.getFullYear();

  const hours = String(newDate.getHours()).padStart(2, "0");
  const minutes = String(newDate.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} à ${hours}:${minutes}`;
};

export const formatDateYearString = frenchDate;
